<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                VAT Payment Detail
              </v-expansion-panel-title>

              <v-expansion-panel-text>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12">
                      <v-card>
                        <v-card-text>
                          <!-- Data Table -->
                          <v-data-table
                            :headers="headers"
                            :items="paymentList"
                            :loading="loading"
                            :search="search"
                            density="compact"
                            :hover="true"
                            :items-per-page="-1"
                            hide-default-footer
                          >
                            <template #item.index="{ index }">{{ index + 1 }}</template>

                            <template #item.voucher_date="{ item }">
                              {{ item.voucher_details?.voucher_date ?? '' }}
                            </template>

                            <template #item.code="{ item }">
                              {{ item.voucher_details?.code ?? '' }}
                            </template>

                            <template #item.account_head="{ item }">
                              {{ item.voucher_details?.account_head?.name ?? '' }}
                            </template>

                            <template #item.account_code="{ item }">
                              {{ item.voucher_details?.account_head?.code ?? '' }}
                            </template>

                            <template #item.amount="{ item }">
                              {{ item.voucher_details?.amount ?? '' }}
                            </template>

                          </v-data-table>

                        </v-card-text>
                      </v-card>

                        <v-card class="mt-8 pa-6" id="printable-challan-area" elevation="1">

                            <!-- TOP RIGHT INFO -->
                            <div class="text-right text-subtitle-2 font-weight-bold">
                                Challan Date: {{ apiData.challan_date }}   
                                &nbsp; | &nbsp;
                                Challan No: {{ apiData.challan_no   }}
                            </div>

                            <!-- TITLE -->
                            <div class="text-center mt-2">
                                <h2 class="font-weight-bold">চালান ফরম</h2>
                                <div>টি,আর ফরম নং ৬ (এস, আর ৩৭ দ্রষ্টব্যঃ)</div>
                            </div>

                            <!-- CHALLAN NO + DATE -->
                            <div class="d-flex  mt-4">
                                <div>
                                চালান নং: ............................................................................
                                </div>
                                <div>
                                তারিখ: .........................................
                                </div>
                            </div>

                            <!-- BANK + BRANCH -->
                            <div class="mt-2">
                                বাংলাদেশ ব্যাংক/সোনালী ব্যাংক লিমিটেডের ................................................................. জেলার ............................................................... শাখায় টাকা জমা দেওয়ার চালান
                            </div>

                            <!-- CODE BOXES -->
                            <div class="text-center font-weight-bold mt-4" style="margin-top: 15px;">
                                কোড নং:
                            </div>

                            <div class="d-flex justify-center mt-1" style="display:flex; justify-content:center; margin-bottom: 20px;">
                                <div v-for="n in 16" :key="n" class="pa-3 text-h6":style="{ width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center',  border: '1px solid #000', visibility: [2,7,12].includes(n) ? 'hidden' : 'visible'}"> </div>
                            </div>

                            <!-- =================== -->
                            <!-- MAIN TABLE SECTION  -->
                            <!-- =================== -->
                            <table class="challan-table mt-6">
                                <thead>
                                <tr>
                                    <th colspan="4">জমা প্র দানকারী কতৃক পূরণ কিরেত হইেব </th>
                                    <th>টাকার অংক</th>
                                    <th rowspan="2">বিভােগর নাম এবং চালােনর পৃাংকনকারী কর্মকর্তার নাম, পদবী ও দপ্তর</th>
                                </tr>
                                <tr>
                                    <th>যাহার মারফত প্রদত্ত ইহার নাম ও ঠিকানা</th>
                                    <th>যে ব্যাক্তি/প্রতিষ্ঠানের পক্ষ হইতে টাকা প্রদত্ত ইহার নাম, পদবী ও ঠিকানা</th>
                                    <th>কি বাবদ জমা দেওয়া হইল তাহার বিবরণ</th>
                                    <th>মুদ্রা ও নোটের বিবরণ / ড্রাফট, পে-অর্ডার ও চেকের বিবরণ</th>
                                    <th>টাকার</th>
                                </tr>
                                </thead>

                                <tbody>
                                <tr>
                                    <!-- Column 1 -->
                                    <td> 
                                        সিলেট গ্যাস ফিল্ডস লিঃ  
                                        <br>চিকনাগুল, সিলেট ভ্যাট রেজিঃ  
                                        <br>নং–২১৭১০৩০৮৫৯ & এরিয়া কোড নং–২০৬১
                                    </td>

                                    <!-- Column 2 -->
                                    <td>সংযুক্ত তালিকা মোতাবেক</td>

                                    <!-- Column 3 -->
                                    <td>
                                        তৃতীয় পক্ষে বিল হইতে উৎসে কর্তনকৃত ভ্যাট
                                        <br>বাবদ অর্থ জমা প্রদান  
                                        <br>অর্থবছর ২০২৫–২০২৬  
                                        <br>তারিখঃ ০১-১০-২০২৫ হইতে ৩১-১০-২০২৫ পর্যন্ত
                                    </td>

                                    <!-- Column 4 -->
                                    <td>---</td>

                                    <!-- Column 5 (Amount) -->
                                    <td class="text-center">
                                        {{ apiData.total_amount   }}
                                    </td>

                                    <!-- Column 6 -->
                                    <td>---</td>
                                </tr>

                                <!-- TOTAL ROW -->
                                <tr>
                                    <td colspan="4" class="text-right font-weight-bold">মোট টাকা</td>
                                    <td class="text-right font-weight-bold">
                                        {{ apiData.total_amount   }}
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td colspan="4" class="text-left font-weight-bold">টাকা(কথায়়) চার শত সাতাশ টাকা পয়সা মাত্র</td>
                                    <td colspan="2" rowspan="3" class="text-center font-weight-bold"> </td>
                                </tr>
                                <tr>
                                    <td colspan="4" class="text-left font-weight-bold">টাকা পাওয়া গেলা</td>
                                </tr>
                                <tr>
                                    <td colspan="4" class="text-left font-weight-bold">তািরখঃ</td>
                                </tr>
                                </tbody>
                            </table>
                        </v-card>

                    </v-col>
                  </v-row>

                  <v-row class="d-print-none mb-4" justify="center">
                      <v-col cols="12" md="8" lg="9" class="d-flex justify-center gap-2">

                          <v-btn color="primary" prepend-icon="mdi-printer" @click="printChallan">
                              Print
                          </v-btn>
                      </v-col>
                  </v-row>

                </v-container>
              </v-expansion-panel-text>

            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

    </v-container>
  </v-app>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";

export default {
  name: "VatPaymentDetails",

  data: () => ({
    panel: [0],
    search: "",
    headers: [
      { title: "#SL", key: "index", sortable: false, width: "7%" },
      { title: "Date", key: "voucher_date" },
      { title: "Voucher No", key: "code" },
      { title: "Account Head", key: "account_head" },
      { title: "Account Code", key: "account_code" },
      { title: "Amount Of VAT", key: "amount", align: "end" }
    ],
  }),

  setup() {
    const store = useStore();
    const loading = ref(true);

    return { store, loading };
  },

  computed: {
    // full API response object
    apiData() {
        console.log(this.store.getters.getVatPaymentDetails.data);
      return this.store.getters.getVatPaymentDetails?.data || {};
    },
    // only payment_details array
    paymentList() {
      return this.apiData?.payment_details ?? [];
    }
  },

  methods:{
      printChallan() {
          const printContent = document.getElementById("printable-challan-area").innerHTML;
          const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}, left=0, top=0`);

          printWindow.document.write(`
              <!DOCTYPE html>
              <html>
              <head>
                  <meta charset="UTF-8">
                  <meta name="viewport" content="width=device-width, initial-scale=1.0">
                  <title>TAX Payment Challan</title>
                  <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
                  <style>
                  body {
                      font-family: 'Times New Roman', serif;
                      background: white;
                      margin: 0;
                      padding: 20px;
                  }
                  .challan-table {
                      width: 100%;
                      border-collapse: collapse;
                      font-size: 12px;
                  }

                  .challan-table th,
                  .challan-table td {
                  border: 1px solid black;
                  padding: 10px;
                  vertical-align: top;
                  }

                  .challan-table th {
                  text-align: center;
                  }
                  .report-paper {
                      background-color: white;
                      color: black;
                      max-width: 100%;
                      width: 100%;
                      margin: auto;
                  }
                  .header-section {
                      display: flex;
                      justify-content: space-between;
                      align-items: flex-start;
                      border-bottom: 2px solid #eee;
                      padding-bottom: 10px;
                      margin-bottom: 16px;
                  }
                  .company-info {
                      flex: 1;
                  }
                  .company-name {
                      color: #333;
                      font-size: 20px;
                      font-weight: bold;
                      text-transform: uppercase;
                      margin: 0 0 4px 0;
                  }
                  .company-text {
                      font-size: 14px;
                      color: #555;
                      margin: 2px 0;
                      display: flex;
                      align-items: center;
                  }
                  .logo-container img {
                      max-height: 70px;
                      max-width: 150px;
                  }
                  .report-title {
                      color: #333;
                      font-size: 20px;
                      font-weight: bold;
                      text-align: center;
                      margin: 16px 0;
                  }
                  .meta-info-box {
                      border: 1px solid #000;
                      margin-bottom: 16px;
                  }
                  .meta-item {
                      height: 35px;
                      display: flex;
                      align-items: center;
                  }
                  .meta-label {
                      font-weight: 500;
                      color: #333;
                      padding-left: 8px;
                  }
                  .meta-value {
                      padding-left: 8px;
                      color: #555;
                  }
                  .d-flex {
                      display: flex;
                  }
                  .dep-table {
                      width: 100%;
                      border-collapse: collapse;
                      font-size: 14px;
                      margin-bottom: 24px;
                  }
                  .dep-table th {
                      background-color: #f0f0f0;
                      border: 1px solid #000;
                      padding: 8px 5px;
                      color: #333;
                  }
                  .dep-table td {
                      border: 1px solid #000;
                      padding: 8px 5px;
                      vertical-align: middle;
                      color: #555;
                  }
                  .text-center {
                      text-align: center;
                  }
                  .text-right {
                      text-align: right;  
                  }
                  .prepared-section {
                      margin-bottom: 32px;
                      color: #555;
                  }
                  .font-weight-bold {
                      font-weight: bold;
                      color: #333;
                  }
                  .text-caption {
                      font-size: 12px;
                      color: #666;
                  }
                  .lines {
                      border-bottom: 2px solid #eee;
                      padding-bottom: 10px;
                  }
                  @page {
                      margin: 0.5in;
                      size: letter;
                  }
                  @media print {
                      body {
                          -webkit-print-color-adjust: exact;
                          print-color-adjust: exact;
                          background: white !important;
                          padding: 0;
                      }
                      .page-header {
                          display: table-header-group;
                      }
                      .page-content {
                          display: table-row-group;
                      }
                  }
                  </style>
              </head>
              <body>
                  ${printContent}
              </body>
              </html>
          `);

          printWindow.document.close();
          printWindow.moveTo(0, 0);
          printWindow.focus();
          
          setTimeout(() => {
              printWindow.print();
              printWindow.onafterprint = () => {
                  printWindow.close();
              };
          }, 1000);
      }
  },

  mounted() {
    const id = this.$route.query.id;
    if (id) {
      this.loading = true;
      this.store.dispatch("getVatPaymentDetails", { id }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}
.challan-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.challan-table th,
.challan-table td {
  border: 1px solid black;
  padding: 10px;
  vertical-align: top;
}

.challan-table th {
  text-align: center;
  font-weight: bold;
}

</style>
